import { computeStats, properties } from "@/data/content";

export default function Stats() {
  const stats = computeStats(properties);
  return (
    <section
      id="results"
      data-testid="stats-section"
      className="border-t border-b border-neutral-800"
    >
      <div className={`max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24`}>
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <p className="overline mb-4">Previous Acquisitions</p>
            <h2 className="font-serif-display text-4xl sm:text-5xl tracking-tight max-w-xl">
              Real outcomes from <span className="italic text-[#36C281]">disciplined buying</span>.
            </h2>
          </div>
          <p className="text-neutral-400 text-sm max-w-sm">
            Live totals — every metric below is calculated directly from the properties I&apos;ve secured for clients. Updated in real time.
          </p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((s) => (
            <div
              key={s.label}
              data-testid={`stat-${s.label.toLowerCase().replace(/[.\s]+/g, "-")}`}
              className="border-l-2 border-[#36C281]/40 pl-5"
            >
              <div className="font-serif-display text-5xl md:text-6xl text-[#EFE9D4]">{s.value}</div>
              <div className="mt-3 text-xs tracking-[0.2em] uppercase text-neutral-500">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
